<div
  *ngIf="visible"
  class="flex flex-col flex-0 w-full overflow-hidden border-b-2 print:hidden"
  [ngClass]="phaseStyle.container"
>
  <div class="flex items-center gap-x-2.5 px-4 md:px-6 py-2">
    <mat-icon class="!w-5 !h-5 !text-xl !leading-5 flex-shrink-0" [ngClass]="phaseStyle.accent">
      {{ phaseStyle.icon }}
    </mat-icon>

    <p class="flex-1 text-sm leading-snug" [ngClass]="phaseStyle.text">
      <span class="font-semibold">{{ phaseStyle.title }}</span>
      <span class="hidden sm:inline">{{ phaseStyle.lead }}</span>
      <span class="sm:hidden">&nbsp;</span>
      <span class="font-semibold tabular-nums" [ngClass]="phaseStyle.accent">
        {{ formattedTime }}
      </span>
      <span class="sm:hidden">
        restante<span *ngIf="paused"> (pausado)</span>
      </span>
      <span class="hidden sm:inline" *ngIf="paused"> · pausado</span>
    </p>

    <button
      mat-stroked-button
      class="flex-shrink-0 whitespace-nowrap"
      [ngClass]="phaseStyle.button"
      (click)="update()"
    >
      <mat-icon class="!w-4 !h-4 !text-base !leading-4 mr-1" [ngClass]="phaseStyle.accent">
        logout
      </mat-icon>
      <span class="hidden sm:inline">Actualizar y salir</span>
      <span class="sm:hidden">Actualizar</span>
    </button>
  </div>

  <div
    class="h-0.5 transition-all duration-1000 ease-linear"
    [ngClass]="phaseStyle.progress"
    [style.width.%]="progressPct"
  ></div>
</div>
